import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
import { DOC2API_URL } from 'pages/APIs';

export default class EmailTemplateApiService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getList(): Promise<any> {
    return super.get(api.email_template_fetch);
  }

  public async getEmailTemplateListByDocType(
    doc_type: string | null,
  ): Promise<any> {
    let queryParams = '';
    if (doc_type) {
      queryParams = '?' + 'doc_type=' + doc_type;
    }
    return super.get(api.email_template_get_by_doc_type + queryParams);
  }

  public async getGeneralList(): Promise<any> {
    const queryParams = 'email_type=' + 'general';
    return super.get(api.email_template_fetch + '?' + queryParams);
  }
  public async getOne(email_template_id: string): Promise<any> {
    return super.get(`${api.email_template_get}/${email_template_id}`);
  }
  public async create(data: any): Promise<any> {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('subject', data.subject);
    formData.append('email_type', data.supplier_type);
    formData.append(
      'include_document_as_attachment',
      data.include_document_as_attachment
        ? data.include_document_as_attachment
        : false,
    );
    formData.append('cc_type', data.cc_type);
    formData.append('body', data.editor_value);
    formData.append('doc_type', data.selected_doc_type ?? '');
    return super.post(api.email_template_create, formData);
  }
  public async update(email_template_id: string, data: any): Promise<any> {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('subject', data.subject);
    formData.append('email_type', data.email_type);
    formData.append(
      'include_document_as_attachment',
      data.include_document_as_attachment
        ? data.include_document_as_attachment
        : false,
    );
    formData.append('cc_type', data.cc_type);
    formData.append('body', data.value);
    formData.append('doc_type', data.doc_type ?? '');
    return super.put(
      `${api.email_template_update}/${email_template_id}`,
      formData,
    );
  }
  public async delete(id: string): Promise<any> {
    return super.delete(`${api.email_template_delete}/${id}`, {});
  }
  public async uploadFile(file: any): Promise<any> {
    const formData = new FormData();
    formData.append('files', file);
    return super.post(api.email_template_upload_file, formData);
  }
  public async getFile(email_template_id: string): Promise<any> {
    return super.get(`${api.email_template_get_file}/${email_template_id}'`);
  }
  public async emailTemplateData(): Promise<any> {
    return super.get(api.email_template_get_data);
  }
  public async sendTest(data: any): Promise<any> {
    return super.post(api.email_template_post_test, data);
  }
}
